import { render } from "./ProductsStore.vue?vue&type=template&id=66587098&scoped=true"
import script from "./ProductsStore.vue?vue&type=script&lang=js"
export * from "./ProductsStore.vue?vue&type=script&lang=js"

import "./ProductsStore.vue?vue&type=style&index=0&id=66587098&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66587098"]])

export default __exports__